var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center h-full"},[_c('div',{staticClass:"ld",class:_vm.customCss,style:({ 'border-left': ("1.1em solid " + _vm.color) })})])}
var staticRenderFns = []

export { render, staticRenderFns }